// extracted by mini-css-extract-plugin
export default {"search":"SearchPage_search__UTpfI","searchContainer":"SearchPage_searchContainer__8ZOjR"};